module.exports = __webpack_public_path__ + "static/background-99f6437cf32fbb2f181d208c000716c4.svg";